<template>
<div class="app-container" v-loading="loading">
  <div class="content">
      <div class="header">
        <div class="left">
          <img src="@/assets/icon_username.png" alt="">
          <img src="@/assets/icon_company.png" alt="">
        </div>
        <div class="right">
            <span>用户名: {{account}}</span>
            <span>企业: {{buname}}</span>
            <!-- <span @click="testPopToLogin">测试跳转到小程序登录页面</span>
            <span @click="initilizeWXSDK">测试jssdk_signature</span> -->
        </div>
      </div>
      <div class="list-title">企业列表</div>
      <div v-for="bu in bulist" :key="bu.id" class="list-item" @click="projectList(bu)">
        <!-- <span>buid: {{bu.id}}</span> -->
        <span>{{bu.name}}</span>
        <i class="el-icon-arrow-right"></i>
      </div>
  </div>
</div>
</template>

<script>

import Axios from 'axios'
const axios = Axios.create({ })
import utils from '@/utils/domain'
import wx from 'weixin-js-sdk'
export default {
components: {

},
data() {
  return {
    bulist: [],
    loading: false,
    account: "",
    buname: ""
  };
},
computed: {

},
watch: {

},
methods: {
  getUrlParams(name) {
      let query = window.location.search.substring(1)
      let res = {}
      window.location.search
        .substring(1)
        .split('&')
        .forEach((item) => {
          let [key, val] = item.split('=')
          key && (res[key] = val)
        })
      return name ? res[name] : res
    },
    getBuList() {
      /// 获取企业列表
        this.loading = true
        let token = this.getUrlParams('token')
        this.$store.state.loginToken = token;
        axios.defaults.withCredentials = true
        token && axios({
          url: utils.getDomain() + '/workspace/listBu',
          method: 'POST',
          headers: {
            'x-api-token': token,
            'Content-Type':'application/json'
          }
        })
        .then(({ data }) => {
          console.log("resp_data", data)
          this.loading = false
          if(data.code === 'common.success') {
            this.bulist = data.data
          }
        })
        .catch(( error ) => {
          this.loading = false
          console.log("error_occur", error)
        })
    },
    getUserInfo() {
        let token = this.getUrlParams('token')
        token && axios({
          url: utils.getDomain() + '/user/load',
          method: 'POST',
          headers: {
            'x-api-token': token,
            'Content-Type':'application/json'
          }
        })
        .then(({ data }) => {
          console.log("resp_user_data", data)
          // this.loading = false
          if(data.code === 'common.success') {
            this.account = data.data.account
            this.buname = data.data.buName
          }

          this.checkLogin(data)
        })
        .catch(( error ) => {
          // this.loading = false
          console.log("error_occur", error)
        })
    },
    projectList(bu){
      console.log("select-bu", bu)
      this.$router.push({path: "/projectlist", query: {
        buid: bu.id
      }})
    },
    checkLogin(data) {

        /// TOKEN expired need login again
        if(data.code === 'tc.common.LoginTokenInvalidException' || 
             data.code === "100004" ||
             data.code === "100001" || 
             data.code === "tc.access.InvalidTokenException") {

               /// post message to user and login
               wx.miniProgram.navigateTo({url:'/pages/login?refresh=true'})
          }
    },
    testPopToLogin() {
        wx.miniProgram.navigateTo({url:'/pages/login/login?refresh=true'})
    },
    initilizeWXSDK() {
      /// 预留JSSDK配置接口
      let url = location.href.split('#')[0]
      console.log("signature_url", url)
      let token = this.getUrlParams('token')
        token && axios({
          url: utils.getDomain() + '/thirdparty/sign',
          method: 'POST',
          headers: {
            'x-api-token': token,
            'Content-Type':'application/json'
          },
          data: {
            "bizType": "WechatH5Workapp",
            "content": url,
            "token": "wechat"
          }
        })
        .then(({ data }) => {
          console.log("initilizeWXSDK", data)
          if(data.code === 'common.success') {
            
            let {appId,nonceStr,signature, timestamp} = JSON.parse(data.data.signatureContent)

            wx.config({
                debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: appId, // 必填，公众号的唯一标识
                timestamp: timestamp, // 必填，生成签名的时间戳
                nonceStr: nonceStr, // 必填，生成签名的随机串
                signature: signature,// 必填，签名，见附录1
                jsApiList: ["closeWindow", "updateAppMessageShareData"] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            });

            wx.ready(function(){
                  console.log("weixin ready")
                  // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
            });
            wx.error(function(res){
              console.log("weixin error", res)
              // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
            });
          }
        })
        .catch(( error ) => {
          console.log("error_occur", error)
        })
    }
},
created() {

},
mounted() {
  /// get token from url , and request bu list
  this.getBuList()
  this.getUserInfo()
},
}
</script>

<style lang="scss" scoped>
  .app-container {
    width: 100vw;
    max-width: 750px;
    font-size: 16px;
    margin: 0 auto;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    .content {
      flex: 1;

      .header {
        display: flex;
        .left {
          width: 80px;
          height: 160px;
          background-color: #333;
          padding-left: 20px;
          display: flex;
          align-items: flex-start;
          justify-content: space-around;
          flex-direction: column;
        }
        .right {
          padding-left: 20px;
          display: flex;
          align-items: flex-start;
          justify-content: space-around;
          flex-direction: column;
        }
      };
      // .list {
      //   .title {

      //   };
      // };
      .list-title {
        padding: 10px;
        height: 20px;
        color: #999;
        font-size: 16px;
      }
      .list-item {
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px;
        margin: 10px;
        margin-top: 15px;
        width: calc(100vw - 40px);
        max-width: 750px;
        box-shadow: 0 0 0 2px #ffffff, 0 0 6px 3px #cccccc;
      }
    }
  }
</style>